import axios from 'axios';

const deleteProductImage = (imageId) => {
  return axios
    .post(`${process.env.REACT_APP_API_URL}/api/product/deleteProductImage`, { _id: imageId })
    .then(res => res)
    .catch(err => err);
};

export default deleteProductImage;
